import type { LibraryFilters } from "@/types/types";
import { CreativeXScore } from "hoxton-shared/enums/creativex";

export default function constructLibraryFiltersQueryVariables(filters: LibraryFilters) {
    const [type, threshold] = filters.creativeXScoreFilters?.split("-") ?? [];

    const aboveScore = type === "over" ? Number(threshold) : CreativeXScore.MIN;
    const bellowScore = type === "under" ? Number(threshold) - 0.01 : CreativeXScore.MAX;

    return {
        filters: {
            editableGroups: filters.groupValueFilters,
            masterTemplateIds: filters.sizeFilters,
            languages: filters.languageFilters
        },
        search: filters.searchFilters,
        status: filters.qaStatusFilters,
        userStatus: filters.qaUserStatusFilters,
        publishedStatus: filters.publishedStatusFilters,
        commentedOnBy: filters.qaCommentedOnByFilters,
        creativeXFilters: filters.creativeXStatusFilters
            ? {
                  ...(filters.creativeXStatusFilters && { status: filters.creativeXStatusFilters }),
                  ...(filters.creativeXScoreFilters && {
                      aboveScore,
                      bellowScore
                  })
              }
            : null,
        sataliaFilters: filters.sataliaStatusFilters ? { status: filters.sataliaStatusFilters } : null,
        ...(filters.dedup && { dedup: filters.dedup }),
        ...(filters.visibleToFilters?.length && { visibleTo: filters.visibleToFilters })
    };
}
